(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ahome-avaliacoes"] && !Shopify.designMode) return;
  try {
    
// Arrasto livre no mouse, mesmo comportamento da vitrine. O toque ja tem
// inercia nativa do sistema; o mouse nao tem fling nenhum, entao o pointer
// vira scroll e a soltura vira desaceleracao.
//
// Tudo por delegacao no document: assim nao importa se este script roda antes
// do trilho existir (bundle no head, secao recarregada pelo editor, etc).
(function () {
  if (window.__aavArrasto) { return; }
  window.__aavArrasto = true;

  var calmo = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var trilho = null, partiuX = 0, partiuScroll = 0, ultimoX = 0, ultimoT = 0, v = 0;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) { return; }
    var alvo = e.target.closest && e.target.closest('[data-aav-trilho]');
    if (!alvo) { return; }
    trilho = alvo; v = 0;
    partiuX = ultimoX = e.clientX;
    partiuScroll = trilho.scrollLeft;
    ultimoT = e.timeStamp;
    trilho.classList.add('is-arrastando');
    if (trilho.setPointerCapture) { trilho.setPointerCapture(e.pointerId); }
  });

  document.addEventListener('pointermove', function (e) {
    if (!trilho) { return; }
    var dt = e.timeStamp - ultimoT;
    if (dt > 0) { v = (e.clientX - ultimoX) / dt; }
    ultimoX = e.clientX;
    ultimoT = e.timeStamp;
    trilho.scrollLeft = partiuScroll - (e.clientX - partiuX);
    e.preventDefault();
  });

  function soltar() {
    if (!trilho) { return; }
    var alvo = trilho;
    trilho = null;
    alvo.classList.remove('is-arrastando');
    if (calmo || Math.abs(v) < 0.1) { return; }
    // inercia: cada quadro come 6% da velocidade ate ela sumir
    var passo = function () {
      alvo.scrollLeft -= v * 16;
      v *= 0.94;
      if (Math.abs(v) > 0.02) { requestAnimationFrame(passo); }
    };
    requestAnimationFrame(passo);
  }
  document.addEventListener('pointerup', soltar);
  document.addEventListener('pointercancel', soltar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahome-ugc"] && !Shopify.designMode) return;
  try {
    
// Nada de autoplay com som: o video so toca no clique, e com som, porque foi
// o usuario que pediu. Um tocando por vez — comecar um pausa o outro.
// Delegacao no document pra nao depender de quando o bundle roda.
(function () {
  if (window.__augVideo) { return; }
  window.__augVideo = true;

  var calmo = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  // o <li> e' quem sobe: o quadro esta dentro de um link com overflow, e o
  // trilho precisa saber que existe um card ativo pra recuar os outros
  function marcar(video, ativo) {
    var item = video.closest && video.closest('.aug__item');
    if (!item) { return; }
    item.classList.toggle('is-ativo', ativo);
    var trilho = item.closest('.aug__trilho');
    if (trilho) {
      trilho.classList.toggle('tem-ativo', !!trilho.querySelector('.aug__item.is-ativo'));
    }
    if (!ativo || !trilho) { return; }
    // centraliza o card que cresceu. Espera dois quadros: a largura nova
    // precisa estar aplicada antes de calcular o meio, senao centraliza o
    // tamanho velho e o card fica torto.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var meio = item.offsetLeft - (trilho.clientWidth - item.offsetWidth) / 2;
        trilho.scrollTo({ left: meio, behavior: calmo ? 'auto' : 'smooth' });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var quadro = e.target.closest && e.target.closest('[data-aug-video]');
    if (!quadro) { return; }
    var video = quadro.querySelector('video');
    if (!video) { return; }

    // os controles ficam dentro do quadro: tratam e saem, senao o clique
    // deles cairia no toggle de play logo abaixo
    if (e.target.closest('[data-aug-mudo]')) {
      video.muted = !video.muted;
      quadro.classList.toggle('is-mudo', video.muted);
      return;
    }
    if (e.target.closest('[data-aug-pausa]')) {
      video.pause();
      quadro.classList.remove('is-tocando');
      marcar(video, false);
      return;
    }

    if (video.paused) {
      document.querySelectorAll('[data-aug-video] video').forEach(function (outro) {
        if (outro !== video) {
          outro.pause();
          outro.closest('[data-aug-video]').classList.remove('is-tocando');
          marcar(outro, false);
        }
      });
      video.muted = false;
      var tocou = video.play();
      if (tocou && tocou.catch) {
        // navegador que barra som sem gesto: cai pro mudo em vez de nao tocar
        tocou.catch(function () { video.muted = true; video.play(); });
      }
      quadro.classList.add('is-tocando');
      quadro.classList.toggle('is-mudo', video.muted);
      marcar(video, true);
    } else {
      video.pause();
      quadro.classList.remove('is-tocando');
      marcar(video, false);
    }
  });

  // entrada escalonada: so arma se o navegador tiver IntersectionObserver,
  // senao a secao fica visivel (o CSS de opacidade depende de .is-armado).
  function armar() {
    if (!('IntersectionObserver' in window)) { return; }
    document.querySelectorAll('[data-aug-animar]').forEach(function (secao) {
      if (secao.classList.contains('is-armado')) { return; }
      secao.classList.add('is-armado');
      var olho = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            entrada.target.classList.add('is-visivel');
            olho.unobserve(entrada.target);
          }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      olho.observe(secao);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armar);
  } else {
    armar();
  }
  // o editor do Shopify recarrega a secao sem recarregar a pagina
  document.addEventListener('shopify:section:load', armar);

  document.addEventListener('ended', function (e) {
    var quadro = e.target.closest && e.target.closest('[data-aug-video]');
    if (quadro) { quadro.classList.remove('is-tocando'); }
    marcar(e.target, false);
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahome-vitrine"] && !Shopify.designMode) return;
  try {
    
// Botao "Adicionar" do card: POST em /cart/add.js pedindo de volta as secoes
// do drawer, e entrega o HTML pro <cart-drawer> do tema renderizar — e' o
// mesmo caminho que o quick-add do Shrine usa, entao o carrinho abre sozinho.
(function () {
  if (window.__aviAdd) { return; }
  window.__aviAdd = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-avi-add]');
    if (!btn) { return; }
    e.preventDefault();
    if (window.console) { console.log('[avi] add', btn.getAttribute('data-avi-add')); }
    if (btn.classList.contains('is-carregando')) { return; }

    var id = btn.getAttribute('data-avi-add');
    var drawer = document.querySelector('cart-drawer');
    var secoes = ['cart-drawer', 'cart-icon-bubble'];
    // window.Shopify.routes nem sempre existe (depende do que o tema injeta).
    // Lendo direto, o handler estourava ANTES do fetch e o clique nao fazia
    // nada — nem o fallback rodava, porque o erro era sincrono.
    var raiz = '/';
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        raiz = window.Shopify.routes.root;
      }
    } catch (err) { raiz = '/'; }

    btn.classList.add('is-carregando');
    var rotulo = btn.querySelector('.avi__add-label');
    var textoOriginal = rotulo ? rotulo.textContent : '';
    if (rotulo) { rotulo.textContent = '...'; }

    fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: secoes.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (dados) {
        if (dados.status) { throw new Error(dados.description || dados.message); }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(dados);
        } else {
          window.location.href = raiz + 'cart';
        }
      })
      .catch(function () {
        // sem drawer ou erro de rede: cai pro carrinho normal, nunca trava
        window.location.href = raiz + 'cart';
      })
      .finally(function () {
        btn.classList.remove('is-carregando');
        if (rotulo) { rotulo.textContent = textoOriginal; }
      });
  });
})();

document.querySelectorAll('.avi').forEach(function (secao) {
  var trilho  = secao.querySelector('[data-avi-trilho]');
  var fila    = secao.querySelector('[data-avi-fila]');
  // os botoes de aba nascem dentro de cada grupo (theme block); aqui eles
  // sobem pro tablist, na ordem dos grupos
  var lista = secao.querySelector('[data-avi-abas]');
  if (lista) {
    Array.prototype.slice.call(secao.querySelectorAll('.avi__grupo > [data-avi-aba]')).forEach(function (botao) {
      var li = document.createElement('li');
      li.className = 'avi__aba-item';
      li.appendChild(botao);
      lista.appendChild(li);
    });
  }
  var abas    = Array.prototype.slice.call(secao.querySelectorAll('[data-avi-aba]'));
  var grupos  = Array.prototype.slice.call(secao.querySelectorAll('[data-avi-grupo]'));
  var barra   = secao.querySelector('[data-avi-barra]');
  var puxador = secao.querySelector('[data-avi-puxador]');
  var setas   = Array.prototype.slice.call(secao.querySelectorAll('[data-avi-seta]'));
  if (!trilho || !fila) { return; }

  var calmo = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  // ---- barra de progresso + estado das setas -------------------------------
  var pintando = false;
  function pintar() {
    pintando = false;
    var corrida = trilho.scrollWidth - trilho.clientWidth;
    var fracao  = trilho.clientWidth / Math.max(trilho.scrollWidth, 1);
    var andado  = corrida > 0 ? trilho.scrollLeft / corrida : 0;

    if (puxador && barra) {
      var largura = Math.max(fracao, 0.08);
      puxador.style.width = (largura * 100) + '%';
      puxador.style.transform =
        'translateX(' + (andado * (barra.clientWidth - barra.clientWidth * largura)) + 'px)';
      barra.style.visibility = corrida > 1 ? 'visible' : 'hidden';
    }
    setas.forEach(function (b) {
      var prev = b.getAttribute('data-avi-seta') === 'prev';
      b.disabled = corrida <= 1 || (prev ? trilho.scrollLeft <= 1
                                         : trilho.scrollLeft >= corrida - 1);
    });
  }
  function agendar() {
    if (pintando) { return; }
    pintando = true;
    requestAnimationFrame(pintar);
  }
  trilho.addEventListener('scroll', agendar, { passive: true });
  window.addEventListener('resize', agendar);

  // ---- abas ----------------------------------------------------------------
  function mostrar(chave) {
    grupos.forEach(function (grupo) {
      grupo.hidden = grupo.getAttribute('data-avi-grupo') !== chave;
    });
    abas.forEach(function (aba) {
      var ativa = aba.getAttribute('data-avi-aba') === chave;
      aba.classList.toggle('is-ativa', ativa);
      aba.setAttribute('aria-selected', String(ativa));
      aba.tabIndex = ativa ? 0 : -1;
      if (ativa) { trilho.setAttribute('aria-labelledby', aba.id); }
    });
    trilho.scrollLeft = 0;
    agendar();
  }
  abas.forEach(function (aba, i) {
    aba.addEventListener('click', function () {
      mostrar(aba.getAttribute('data-avi-aba'));
    });
    // teclado do tablist: setas andam entre abas, Home/End vao pras pontas
    aba.addEventListener('keydown', function (e) {
      var passo = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      var alvo  = e.key === 'Home' ? 0 : e.key === 'End' ? abas.length - 1
                : passo ? (i + passo + abas.length) % abas.length : -1;
      if (alvo < 0) { return; }
      e.preventDefault();
      abas[alvo].focus();
      abas[alvo].click();
    });
  });
  if (abas.length) { mostrar(abas[0].getAttribute('data-avi-aba')); }

  // ---- arrasto livre no mouse ---------------------------------------------
  // O toque ja tem inercia nativa do sistema; o mouse nao tem fling nenhum,
  // entao aqui o pointer vira scroll e a soltura vira desaceleracao.
  var arrastando = false, partiuX = 0, partiuScroll = 0, ultimoX = 0, ultimoT = 0, v = 0, andou = 0;

  trilho.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) { return; }
    arrastando = true; andou = 0; v = 0;
    partiuX = ultimoX = e.clientX;
    partiuScroll = trilho.scrollLeft;
    ultimoT = e.timeStamp;
    trilho.classList.add('is-arrastando');
    // NAO capturar o ponteiro aqui: setPointerCapture no pointerdown
    // redireciona pointerup/click pro trilho e o clique nunca chega no
    // botao "Adicionar" (bug de 15/09/2026). Captura so quando vira arrasto.
  });

  trilho.addEventListener('pointermove', function (e) {
    if (!arrastando) { return; }
    var dt = e.timeStamp - ultimoT;
    if (dt > 0) { v = (e.clientX - ultimoX) / dt; }
    ultimoX = e.clientX;
    ultimoT = e.timeStamp;
    andou = Math.abs(e.clientX - partiuX);
    if (andou > 6 && !trilho.hasPointerCapture(e.pointerId)) {
      try { trilho.setPointerCapture(e.pointerId); } catch (err) { /* pointerId invalido: segue sem captura */ }
    }
    trilho.scrollLeft = partiuScroll - (e.clientX - partiuX);
  });

  function soltar() {
    if (!arrastando) { return; }
    arrastando = false;
    trilho.classList.remove('is-arrastando');
    if (calmo || Math.abs(v) < 0.1) { return; }
    // inercia: cada quadro come 6% da velocidade ate ela sumir
    var passo = function () {
      trilho.scrollLeft -= v * 16;
      v *= 0.94;
      if (Math.abs(v) > 0.02) { requestAnimationFrame(passo); }
    };
    requestAnimationFrame(passo);
  }
  trilho.addEventListener('pointerup', soltar);
  trilho.addEventListener('pointercancel', soltar);
  // arrasto nao pode virar clique no card
  trilho.addEventListener('click', function (e) {
    if (andou > 6) { e.preventDefault(); e.stopPropagation(); andou = 0; }
  }, true);

  // ---- barra arrastavel ----------------------------------------------------
  if (barra) {
    var puxando = false;
    var levar = function (clientX) {
      var caixa = barra.getBoundingClientRect();
      var largura = puxador ? puxador.offsetWidth : 0;
      var util = Math.max(caixa.width - largura, 1);
      var pos = Math.min(Math.max(clientX - caixa.left - largura / 2, 0), util);
      trilho.scrollLeft = (pos / util) * (trilho.scrollWidth - trilho.clientWidth);
    };
    barra.addEventListener('pointerdown', function (e) {
      puxando = true;
      barra.setPointerCapture(e.pointerId);
      levar(e.clientX);
    });
    barra.addEventListener('pointermove', function (e) { if (puxando) { levar(e.clientX); } });
    barra.addEventListener('pointerup', function () { puxando = false; });
    barra.addEventListener('pointercancel', function () { puxando = false; });
  }

  // ---- setas ---------------------------------------------------------------
  setas.forEach(function (botao) {
    botao.addEventListener('click', function () {
      var slide = fila.querySelector('.avi__grupo:not([hidden]) .avi__slide');
      var gap = parseFloat(getComputedStyle(fila).columnGap) || 0;
      var passo = slide ? slide.getBoundingClientRect().width + gap : trilho.clientWidth * 0.8;
      var sinal = botao.getAttribute('data-avi-seta') === 'prev' ? -1 : 1;
      trilho.scrollBy({ left: passo * sinal, behavior: calmo ? 'auto' : 'smooth' });
    });
  });

  agendar();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aristocrata-deo-hero-v2"] && !Shopify.designMode) return;
  try {
    
  /* ---- aquecimento dos slides ----
     Os slides 2..5 sao `lazy` pra nao disputar banda com o LCP. Depois que
     a pagina termina de carregar, a fila esta vazia: aqui eles sao puxados
     em marcha lenta pra que o primeiro swipe nao caia em imagem vazia, e
     pra que o PAINT do swipe nao espere decodificacao (isso conta no INP). */
  (function () {
    function aquecer() {
      var imgs = document.querySelectorAll('.ahero__slide-img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].setAttribute('fetchpriority', 'low');
        imgs[i].loading = 'eager';
        if (imgs[i].decode) { imgs[i].decode().catch(function () {}); }
      }
    }
    function agendar() {
      if (window.requestIdleCallback) { requestIdleCallback(aquecer, { timeout: 3000 }); }
      else { setTimeout(aquecer, 1200); }
    }
    if (document.readyState === 'complete') { agendar(); }
    else { window.addEventListener('load', agendar); }
  })();

  /* Slider do card da hero. O trilho e scroll-snap: o swipe do mobile e o
     teclado ja funcionam sem JS. Isso aqui so liga setas, barra e estado. */
  (function () {
    function ligar(card) {
      if (card.dataset.aheroPronto) return;
      card.dataset.aheroPronto = '1';

      var trilho = card.querySelector('[data-ahero-trilho]');
      var slides = card.querySelectorAll('.ahero__slide');
      var prev = card.querySelector('[data-ahero-prev]');
      var next = card.querySelector('[data-ahero-next]');
      var ticos = card.querySelectorAll('[data-ahero-ir]');
      if (!trilho || slides.length < 2) return;

      var atual = 0;

      function ir(i) {
        atual = Math.max(0, Math.min(slides.length - 1, i));
        trilho.scrollTo({ left: slides[atual].offsetLeft, behavior: 'smooth' });
        pintar();
      }

      function pintar() {
        for (var i = 0; i < ticos.length; i++) {
          ticos[i].setAttribute('aria-current', i === atual ? 'true' : 'false');
        }
        if (prev) prev.disabled = atual === 0;
        if (next) next.disabled = atual === slides.length - 1;
      }

      if (prev) prev.addEventListener('click', function () { ir(atual - 1); });
      if (next) next.addEventListener('click', function () { ir(atual + 1); });

      for (var i = 0; i < ticos.length; i++) {
        (function (alvo) {
          ticos[alvo].addEventListener('click', function () { ir(alvo); });
        })(i);
      }

      trilho.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); ir(atual - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); ir(atual + 1); }
      });

      /* o swipe muda o scroll sem passar por ir(): le de volta quem esta na tela */
      var timer;
      trilho.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var meio = trilho.scrollLeft + trilho.clientWidth / 2;
          for (var i = 0; i < slides.length; i++) {
            if (meio >= slides[i].offsetLeft && meio < slides[i].offsetLeft + slides[i].offsetWidth) {
              atual = i;
              break;
            }
          }
          pintar();
        }, 90);
      }, { passive: true });

      pintar();
    }

    function varrer() {
      var cards = document.querySelectorAll('[data-ahero-slider]');
      for (var i = 0; i < cards.length; i++) ligar(cards[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', varrer);
    } else {
      varrer();
    }
    /* o editor de tema remonta a secao a cada mudanca */
    document.addEventListener('shopify:section:load', varrer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aristocrata-deo-pdp-v2"] && !Shopify.designMode) return;
  try {
    
  /* Barra de volta pro seletor de kits. Aparece quando a PDP passou por CIMA
     da tela (rect.bottom <= 0) e some quando ela volta a aparecer ou quando a
     pessoa ainda esta ACIMA dela. */
  (function () {
    var secoes = document.querySelectorAll('.apdp');

    for (var i = 0; i < secoes.length; i++) {
      (function (secao) {
        var barra = secao.querySelector('[data-apdp-volta]');
        if (!barra || !window.IntersectionObserver) return;

        var vigia = new IntersectionObserver(function (entradas) {
          for (var k = 0; k < entradas.length; k++) {
            var e = entradas[k];
            var passou = !e.isIntersecting && e.boundingClientRect.bottom <= 0;
            barra.classList.toggle('is-visivel', passou);
          }
        }, { threshold: 0 });

        vigia.observe(secao);
      })(secoes[i]);
    }
  })();

  /* Rolagem suave pros links de ancora da pagina (botao da hero, faixa,
     barra de volta). Guarda no window: um handler so, mesmo com a secao
     repetida. */
  (function () {
    if (window.__aristocrataAncoras) return;
    window.__aristocrataAncoras = true;

    document.addEventListener('click', function (evento) {
      var alvo = evento.target.closest ? evento.target.closest('a[href^="#"]') : null;
      if (!alvo) return;

      var id = alvo.getAttribute('href').slice(1);
      if (!id) return;

      var destino = document.getElementById(id);
      if (!destino) return;

      evento.preventDefault();
      var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      destino.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'start' });
    });
  })();

  /* Um clique toca com som e pausa todo video da pagina - dois audios
     simultaneos e' o pior defeito de uma tira de UGC. */
  (function () {
    var molduras = document.querySelectorAll('[data-apdp-video]');

    /* Sai da tela, pausa. */
    var vigia = null;
    if (window.IntersectionObserver) {
      vigia = new IntersectionObserver(function (entradas) {
        for (var k = 0; k < entradas.length; k++) {
          if (!entradas[k].isIntersecting) {
            var v = entradas[k].target.querySelector('video');
            if (v && !v.paused) v.pause();
          }
        }
      }, { threshold: 0.35 });
    }

    for (var i = 0; i < molduras.length; i++) {
      (function (moldura) {
        var video = moldura.querySelector('video');
        if (!video) return;

        moldura.addEventListener('click', function () {
          if (video.paused) {
            var todos = document.querySelectorAll('video');
            for (var j = 0; j < todos.length; j++) {
              if (todos[j] !== video) todos[j].pause();
            }
            video.muted = false;
            video.play();
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', function () { moldura.classList.add('is-tocando'); });
        video.addEventListener('pause', function () { moldura.classList.remove('is-tocando'); });
        video.addEventListener('ended', function () { video.pause(); });
        if (vigia) vigia.observe(moldura);
      })(molduras[i]);
    }
  })();

  /* ---- pre-decodificar as artes dos kits ----
     Trocar o `src` no clique obriga o navegador a baixar E decodificar a
     arte antes de pintar. Enquanto isso, a interacao fica sem resposta
     visivel - e e' exatamente isso que o INP mede. Depois do load, em
     tempo ocioso, as cinco artes entram no cache ja decodificadas. */
  (function () {
    function preparar() {
      var radios = document.querySelectorAll('input[name="ApdpKits"][data-foto]');
      for (var i = 0; i < radios.length; i++) {
        var url = radios[i].getAttribute('data-foto');
        if (!url) continue;
        var img = new Image();
        img.decoding = 'async';
        img.src = url;
        if (img.decode) { img.decode().catch(function () {}); }
      }
    }
    function agendar() {
      if (window.requestIdleCallback) { requestIdleCallback(preparar, { timeout: 4000 }); }
      else { setTimeout(preparar, 1500); }
    }
    if (document.readyState === 'complete') { agendar(); }
    else { window.addEventListener('load', agendar); }
  })();

  /* ---- galeria em trilho ----
     Quem manda no estado e' a POSICAO do trilho, nao o clique. Arrastar,
     clicar numa miniatura e marcar um kit sao tres jeitos de mover a mesma
     coisa; se cada um acendesse a miniatura por conta propria, eles
     divergiriam na primeira vez que o dedo parasse no meio do caminho. */
  (function () {
    function iniciar(secao) {
      var trilho = secao.querySelector('[data-apdp-trilho]');
      if (!trilho) return;
      var midias = trilho.querySelectorAll('.apdp__midia');
      var thumbs = secao.querySelectorAll('.apdp__thumb');
      if (!midias.length) return;

      var atual = 0;

      function acender(indice) {
        for (var i = 0; i < thumbs.length; i++) {
          var n = parseInt(thumbs[i].getAttribute('data-indice'), 10);
          /* nas artes de kit nenhuma miniatura acende: elas nao tem uma. */
          thumbs[i].classList.toggle('apdp__thumb--on', n === indice);
        }
      }

      function irPara(indice) {
        if (indice < 0) indice = 0;
        if (indice > midias.length - 1) indice = midias.length - 1;
        var destino = midias[indice].offsetLeft - midias[0].offsetLeft;
        if (trilho.scrollTo) { trilho.scrollTo({ left: destino, behavior: 'smooth' }); }
        else { trilho.scrollLeft = destino; }
      }

      if (window.IntersectionObserver) {
        var vigia = new IntersectionObserver(function (entradas) {
          for (var i = 0; i < entradas.length; i++) {
            if (entradas[i].isIntersecting && entradas[i].intersectionRatio >= 0.6) {
              atual = parseInt(entradas[i].target.getAttribute('data-indice'), 10) || 0;
              acender(atual);
            }
          }
        }, { root: trilho, threshold: [0.6] });
        for (var m = 0; m < midias.length; m++) { vigia.observe(midias[m]); }
      }

      secao.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('.apdp__thumb') : null;
        if (!t) return;
        /* o "+N" avanca uma midia a partir de onde o trilho esta - e' o
           unico controle que chega nas artes de kit sem o seletor. */
        if (t.classList.contains('apdp__thumb--mais')) { irPara(atual + 1); return; }
        irPara(parseInt(t.getAttribute('data-indice'), 10) || 0);
      });

      /* Marcar um kit leva o trilho ate a arte dele. O contrario NAO vale:
         arrastar ate uma arte nao marca kit, senao explorar as imagens
         trocaria o preco sem a pessoa pedir. */
      document.addEventListener('change', function (e) {
        if (!e.target || e.target.name !== 'ApdpKits') return;
        if (!secao.contains(e.target)) return;
        var alvo = secao.querySelector('.apdp__midia--kit[data-kit="' + String(e.target.value).replace(/"/g, '\\"') + '"]');
        if (alvo) { irPara(parseInt(alvo.getAttribute('data-indice'), 10) || 0); }
      });

      acender(0);
    }

    var secoes = document.querySelectorAll('.apdp');
    for (var i = 0; i < secoes.length; i++) { iniciar(secoes[i]); }
  })();

  /* ---- add to cart ----
     Uma variante por kit, entao o carrinho leva UMA linha. Os sabonetes
     gratis nao sao line items: viajam como line item property, que o
     Shopify mostra no carrinho, no pedido e imprime na etiqueta.
     Sem produto configurado no editor o botao continua inerte - melhor
     nao fazer nada do que mandar pro carrinho um id vazio. */
  (function () {
    function moeda(b) { return b.getAttribute('data-rotulo') || b.textContent; }

    /* Voltar pela seta do navegador restaura a pagina do bfcache com o DOM
       exatamente como estava: o botao voltava congelado em "Adicionando..."
       e com data-ocupado, o que o deixava morto. `pageshow` roda tambem na
       restauracao (event.persisted), entao e' onde o estado se desfaz. */
    function destravar() {
      var botoes = document.querySelectorAll('[data-apdp-comprar]');
      for (var i = 0; i < botoes.length; i++) {
        var b = botoes[i];
        var rot = b.getAttribute('data-rotulo');
        if (rot) { b.textContent = rot; }
        b.dataset.ocupado = '';
        var erro = b.parentNode && b.parentNode.querySelector('.apdp__cta-erro');
        if (erro) { erro.remove(); }
      }
    }
    window.addEventListener('pageshow', destravar);

    document.addEventListener('click', function (e) {
      var botao = e.target.closest ? e.target.closest('[data-apdp-comprar]') : null;
      if (!botao) return;
      var secao = botao.closest('.apdp');
      if (!secao) return;
      var escolhido = secao.querySelector('input[name="ApdpKits"]:checked');
      if (!escolhido) return;
      var id = escolhido.getAttribute('data-variante');
      if (!id) return;

      e.preventDefault();
      if (botao.dataset.ocupado) return;
      botao.dataset.ocupado = '1';
      botao.setAttribute('data-rotulo', botao.textContent);
      botao.textContent = 'Adicionando...';

      /* Sem line item property: o TITULO DA VARIANTE ja diz o brinde
         ("3 desodorantes + 5 sabonetes") e sai no carrinho, no pedido e na
         etiqueta. Property so repetiria a mesma informacao. */
      /* Mesmo fluxo do formulario de produto do tema: pede as SEÇOES do
         carrinho junto com o add e entrega a resposta pro elemento
         <cart-drawer>, que se atualiza e desliza sozinho. Sem redirect.
         Se o tema nao expuser o drawer, cai no destino configurado. */
      var gaveta = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var carga = { id: Number(id), quantity: 1 };
      if (gaveta && typeof gaveta.getSectionsToRender === 'function') {
        carga.sections = gaveta.getSectionsToRender().map(function (x) { return x.id; });
        carga.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(carga)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && !res.id) { throw res; }
          botao.textContent = moeda(botao);
          botao.dataset.ocupado = '';
          if (gaveta && typeof gaveta.renderContents === 'function') {
            if (gaveta.classList.contains('is-empty')) { gaveta.classList.remove('is-empty'); }
            gaveta.renderContents(res);
          } else {
            window.location.href = botao.getAttribute('data-destino') || '/cart';
          }
        })
        .catch(function () {
          botao.textContent = moeda(botao);
          botao.dataset.ocupado = '';
          botao.insertAdjacentHTML('afterend',
            '<div class="apdp__cta-erro">Não deu pra adicionar agora. Tente de novo.</div>');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aristocrata-desodorante-comousar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var midias = document.querySelectorAll('[data-acomo-media]');
    if (!midias.length) return;

    // com movimento reduzido a capa basta - GIF nao tem controle de pausa
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function ligar(media) {
      var gif = media.querySelector('[data-acomo-gif]');
      var url = media.getAttribute('data-gif');
      if (!gif || !url) return;
      if (!gif.getAttribute('src')) gif.setAttribute('src', url);
      media.classList.add('esta-tocando');
    }

    // o laco e' infinito por conta do proprio GIF: o JS so decide QUANDO baixar
    if (!('IntersectionObserver' in window)) {
      for (var k = 0; k < midias.length; k++) ligar(midias[k]);
      return;
    }
    var olho = new IntersectionObserver(function (entradas) {
      for (var j = 0; j < entradas.length; j++) {
        if (!entradas[j].isIntersecting) continue;
        ligar(entradas[j].target);
        olho.unobserve(entradas[j].target);
      }
    }, { threshold: 0.2, rootMargin: '200px 0px' });
    for (var i = 0; i < midias.length; i++) olho.observe(midias[i]);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aristocrata-desodorante-depoimentos"] && !Shopify.designMode) return;
  try {
    
  /* A esteira e' 100% CSS. O JS aqui so liga as classes que dependem de
     setting, porque a folha de estilo da secao nao aceita Liquid dentro. */
  (function () {
    var trilhos = document.querySelectorAll('[data-adep-trilho]');

    for (var i = 0; i < trilhos.length; i++) {
      var t = trilhos[i];
      var inverso = String(t.dataset.adepInverso || '').toLowerCase();
      var pausa = String(t.dataset.adepPausa || '').toLowerCase();
      if (inverso === 'true') t.classList.add('adep__trilho--inverso');
      if (pausa !== 'false') t.classList.add('adep__trilho--pausavel');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aristocrata-desodorante-hero"] && !Shopify.designMode) return;
  try {
    
  /* ---- aquecimento dos slides ----
     Os slides 2..5 sao `lazy` pra nao disputar banda com o LCP. Depois que
     a pagina termina de carregar, a fila esta vazia: aqui eles sao puxados
     em marcha lenta pra que o primeiro swipe nao caia em imagem vazia, e
     pra que o PAINT do swipe nao espere decodificacao (isso conta no INP). */
  (function () {
    function aquecer() {
      var imgs = document.querySelectorAll('.ahero__slide-img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].setAttribute('fetchpriority', 'low');
        imgs[i].loading = 'eager';
        if (imgs[i].decode) { imgs[i].decode().catch(function () {}); }
      }
    }
    function agendar() {
      if (window.requestIdleCallback) { requestIdleCallback(aquecer, { timeout: 3000 }); }
      else { setTimeout(aquecer, 1200); }
    }
    if (document.readyState === 'complete') { agendar(); }
    else { window.addEventListener('load', agendar); }
  })();

  /* Slider do card da hero. O trilho e scroll-snap: o swipe do mobile e o
     teclado ja funcionam sem JS. Isso aqui so liga setas, barra e estado. */
  (function () {
    function ligar(card) {
      if (card.dataset.aheroPronto) return;
      card.dataset.aheroPronto = '1';

      var trilho = card.querySelector('[data-ahero-trilho]');
      var slides = card.querySelectorAll('.ahero__slide');
      var prev = card.querySelector('[data-ahero-prev]');
      var next = card.querySelector('[data-ahero-next]');
      var ticos = card.querySelectorAll('[data-ahero-ir]');
      if (!trilho || slides.length < 2) return;

      var atual = 0;

      function ir(i) {
        atual = Math.max(0, Math.min(slides.length - 1, i));
        trilho.scrollTo({ left: slides[atual].offsetLeft, behavior: 'smooth' });
        pintar();
      }

      function pintar() {
        for (var i = 0; i < ticos.length; i++) {
          ticos[i].setAttribute('aria-current', i === atual ? 'true' : 'false');
        }
        if (prev) prev.disabled = atual === 0;
        if (next) next.disabled = atual === slides.length - 1;
      }

      if (prev) prev.addEventListener('click', function () { ir(atual - 1); });
      if (next) next.addEventListener('click', function () { ir(atual + 1); });

      for (var i = 0; i < ticos.length; i++) {
        (function (alvo) {
          ticos[alvo].addEventListener('click', function () { ir(alvo); });
        })(i);
      }

      trilho.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); ir(atual - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); ir(atual + 1); }
      });

      /* o swipe muda o scroll sem passar por ir(): le de volta quem esta na tela */
      var timer;
      trilho.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var meio = trilho.scrollLeft + trilho.clientWidth / 2;
          for (var i = 0; i < slides.length; i++) {
            if (meio >= slides[i].offsetLeft && meio < slides[i].offsetLeft + slides[i].offsetWidth) {
              atual = i;
              break;
            }
          }
          pintar();
        }, 90);
      }, { passive: true });

      pintar();
    }

    function varrer() {
      var cards = document.querySelectorAll('[data-ahero-slider]');
      for (var i = 0; i < cards.length; i++) ligar(cards[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', varrer);
    } else {
      varrer();
    }
    /* o editor de tema remonta a secao a cada mudanca */
    document.addEventListener('shopify:section:load', varrer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aristocrata-desodorante-pdp"] && !Shopify.designMode) return;
  try {
    
  /* Barra de volta pro seletor de kits. Aparece quando a PDP passou por CIMA
     da tela (rect.bottom <= 0) e some quando ela volta a aparecer ou quando a
     pessoa ainda esta ACIMA dela. */
  (function () {
    var secoes = document.querySelectorAll('.apdp');

    for (var i = 0; i < secoes.length; i++) {
      (function (secao) {
        var barra = secao.querySelector('[data-apdp-volta]');
        if (!barra || !window.IntersectionObserver) return;

        var vigia = new IntersectionObserver(function (entradas) {
          for (var k = 0; k < entradas.length; k++) {
            var e = entradas[k];
            var passou = !e.isIntersecting && e.boundingClientRect.bottom <= 0;
            barra.classList.toggle('is-visivel', passou);
          }
        }, { threshold: 0 });

        vigia.observe(secao);
      })(secoes[i]);
    }
  })();

  /* Rolagem suave pros links de ancora da pagina (botao da hero, faixa,
     barra de volta). Guarda no window: um handler so, mesmo com a secao
     repetida. */
  (function () {
    if (window.__aristocrataAncoras) return;
    window.__aristocrataAncoras = true;

    document.addEventListener('click', function (evento) {
      var alvo = evento.target.closest ? evento.target.closest('a[href^="#"]') : null;
      if (!alvo) return;

      var id = alvo.getAttribute('href').slice(1);
      if (!id) return;

      var destino = document.getElementById(id);
      if (!destino) return;

      evento.preventDefault();
      var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      destino.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'start' });
    });
  })();

  /* Um clique toca com som e pausa todo video da pagina - dois audios
     simultaneos e' o pior defeito de uma tira de UGC. */
  (function () {
    var molduras = document.querySelectorAll('[data-apdp-video]');

    /* Sai da tela, pausa. */
    var vigia = null;
    if (window.IntersectionObserver) {
      vigia = new IntersectionObserver(function (entradas) {
        for (var k = 0; k < entradas.length; k++) {
          if (!entradas[k].isIntersecting) {
            var v = entradas[k].target.querySelector('video');
            if (v && !v.paused) v.pause();
          }
        }
      }, { threshold: 0.35 });
    }

    for (var i = 0; i < molduras.length; i++) {
      (function (moldura) {
        var video = moldura.querySelector('video');
        if (!video) return;

        moldura.addEventListener('click', function () {
          if (video.paused) {
            var todos = document.querySelectorAll('video');
            for (var j = 0; j < todos.length; j++) {
              if (todos[j] !== video) todos[j].pause();
            }
            video.muted = false;
            video.play();
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', function () { moldura.classList.add('is-tocando'); });
        video.addEventListener('pause', function () { moldura.classList.remove('is-tocando'); });
        video.addEventListener('ended', function () { video.pause(); });
        if (vigia) vigia.observe(moldura);
      })(molduras[i]);
    }
  })();

  /* ---- pre-decodificar as artes dos kits ----
     Trocar o `src` no clique obriga o navegador a baixar E decodificar a
     arte antes de pintar. Enquanto isso, a interacao fica sem resposta
     visivel - e e' exatamente isso que o INP mede. Depois do load, em
     tempo ocioso, as cinco artes entram no cache ja decodificadas. */
  (function () {
    function preparar() {
      var radios = document.querySelectorAll('input[name="ApdpKits"][data-foto]');
      for (var i = 0; i < radios.length; i++) {
        var url = radios[i].getAttribute('data-foto');
        if (!url) continue;
        var img = new Image();
        img.decoding = 'async';
        img.src = url;
        if (img.decode) { img.decode().catch(function () {}); }
      }
    }
    function agendar() {
      if (window.requestIdleCallback) { requestIdleCallback(preparar, { timeout: 4000 }); }
      else { setTimeout(preparar, 1500); }
    }
    if (document.readyState === 'complete') { agendar(); }
    else { window.addEventListener('load', agendar); }
  })();

  /* ---- galeria em trilho ----
     Quem manda no estado e' a POSICAO do trilho, nao o clique. Arrastar,
     clicar numa miniatura e marcar um kit sao tres jeitos de mover a mesma
     coisa; se cada um acendesse a miniatura por conta propria, eles
     divergiriam na primeira vez que o dedo parasse no meio do caminho. */
  (function () {
    function iniciar(secao) {
      var trilho = secao.querySelector('[data-apdp-trilho]');
      if (!trilho) return;
      var midias = trilho.querySelectorAll('.apdp__midia');
      var thumbs = secao.querySelectorAll('.apdp__thumb');
      if (!midias.length) return;

      var atual = 0;

      function acender(indice) {
        for (var i = 0; i < thumbs.length; i++) {
          var n = parseInt(thumbs[i].getAttribute('data-indice'), 10);
          /* nas artes de kit nenhuma miniatura acende: elas nao tem uma. */
          thumbs[i].classList.toggle('apdp__thumb--on', n === indice);
        }
      }

      function irPara(indice) {
        if (indice < 0) indice = 0;
        if (indice > midias.length - 1) indice = midias.length - 1;
        var destino = midias[indice].offsetLeft - midias[0].offsetLeft;
        if (trilho.scrollTo) { trilho.scrollTo({ left: destino, behavior: 'smooth' }); }
        else { trilho.scrollLeft = destino; }
      }

      if (window.IntersectionObserver) {
        var vigia = new IntersectionObserver(function (entradas) {
          for (var i = 0; i < entradas.length; i++) {
            if (entradas[i].isIntersecting && entradas[i].intersectionRatio >= 0.6) {
              atual = parseInt(entradas[i].target.getAttribute('data-indice'), 10) || 0;
              acender(atual);
            }
          }
        }, { root: trilho, threshold: [0.6] });
        for (var m = 0; m < midias.length; m++) { vigia.observe(midias[m]); }
      }

      secao.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('.apdp__thumb') : null;
        if (!t) return;
        /* o "+N" avanca uma midia a partir de onde o trilho esta - e' o
           unico controle que chega nas artes de kit sem o seletor. */
        if (t.classList.contains('apdp__thumb--mais')) { irPara(atual + 1); return; }
        irPara(parseInt(t.getAttribute('data-indice'), 10) || 0);
      });

      /* Marcar um kit leva o trilho ate a arte dele. O contrario NAO vale:
         arrastar ate uma arte nao marca kit, senao explorar as imagens
         trocaria o preco sem a pessoa pedir. */
      document.addEventListener('change', function (e) {
        if (!e.target || e.target.name !== 'ApdpKits') return;
        if (!secao.contains(e.target)) return;
        var alvo = secao.querySelector('.apdp__midia--kit[data-kit="' + String(e.target.value).replace(/"/g, '\\"') + '"]');
        if (alvo) { irPara(parseInt(alvo.getAttribute('data-indice'), 10) || 0); }
      });

      acender(0);
    }

    var secoes = document.querySelectorAll('.apdp');
    for (var i = 0; i < secoes.length; i++) { iniciar(secoes[i]); }
  })();

  /* ---- add to cart ----
     Uma variante por kit, entao o carrinho leva UMA linha. Os sabonetes
     gratis nao sao line items: viajam como line item property, que o
     Shopify mostra no carrinho, no pedido e imprime na etiqueta.
     Sem produto configurado no editor o botao continua inerte - melhor
     nao fazer nada do que mandar pro carrinho um id vazio. */
  (function () {
    function moeda(b) { return b.getAttribute('data-rotulo') || b.textContent; }

    /* Voltar pela seta do navegador restaura a pagina do bfcache com o DOM
       exatamente como estava: o botao voltava congelado em "Adicionando..."
       e com data-ocupado, o que o deixava morto. `pageshow` roda tambem na
       restauracao (event.persisted), entao e' onde o estado se desfaz. */
    function destravar() {
      var botoes = document.querySelectorAll('[data-apdp-comprar]');
      for (var i = 0; i < botoes.length; i++) {
        var b = botoes[i];
        var rot = b.getAttribute('data-rotulo');
        if (rot) { b.textContent = rot; }
        b.dataset.ocupado = '';
        var erro = b.parentNode && b.parentNode.querySelector('.apdp__cta-erro');
        if (erro) { erro.remove(); }
      }
    }
    window.addEventListener('pageshow', destravar);

    document.addEventListener('click', function (e) {
      var botao = e.target.closest ? e.target.closest('[data-apdp-comprar]') : null;
      if (!botao) return;
      var secao = botao.closest('.apdp');
      if (!secao) return;
      var escolhido = secao.querySelector('input[name="ApdpKits"]:checked');
      if (!escolhido) return;
      var id = escolhido.getAttribute('data-variante');
      if (!id) return;

      e.preventDefault();
      if (botao.dataset.ocupado) return;
      botao.dataset.ocupado = '1';
      botao.setAttribute('data-rotulo', botao.textContent);
      botao.textContent = 'Adicionando...';

      /* Sem line item property: o TITULO DA VARIANTE ja diz o brinde
         ("3 desodorantes + 5 sabonetes") e sai no carrinho, no pedido e na
         etiqueta. Property so repetiria a mesma informacao. */
      /* O setting "destino" manda no que acontece depois do add:
         - "/checkout": pula a gaveta e o carrinho, vai direto pro pagamento.
         - "/cart" (padrao): abre a gaveta lateral do tema sem sair da pagina;
           se o tema nao expuser a gaveta, cai no carrinho.
         No caminho do checkout nao pedimos as SEÇOES do carrinho, porque a
         gaveta nao vai ser renderizada. */
      var destino = botao.getAttribute('data-destino') || '/cart';
      var direto = destino === '/checkout';
      var gaveta = direto ? null : (document.querySelector('cart-notification') || document.querySelector('cart-drawer'));
      var carga = { id: Number(id), quantity: 1 };
      if (gaveta && typeof gaveta.getSectionsToRender === 'function') {
        carga.sections = gaveta.getSectionsToRender().map(function (x) { return x.id; });
        carga.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(carga)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && !res.id) { throw res; }
          if (direto) {
            botao.textContent = 'Indo pro checkout...';
            window.location.href = '/checkout';
            return;
          }
          botao.textContent = moeda(botao);
          botao.dataset.ocupado = '';
          if (gaveta && typeof gaveta.renderContents === 'function') {
            if (gaveta.classList.contains('is-empty')) { gaveta.classList.remove('is-empty'); }
            gaveta.renderContents(res);
          } else {
            window.location.href = destino;
          }
        })
        .catch(function () {
          botao.textContent = moeda(botao);
          botao.dataset.ocupado = '';
          botao.insertAdjacentHTML('afterend',
            '<div class="apdp__cta-erro">Não deu pra adicionar agora. Tente de novo.</div>');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aristocrata-desodorante-produto"] && !Shopify.designMode) return;
  try {
    
  /* Abertura do tubo: linha do tempo por rAF, disparada quando o palco
     entra na tela. Nao usa scroll - a fluidez de um scrub e' limitada
     pelo dispositivo de entrada, e roda de mouse anda aos saltos.

     Indice fracionario: o inteiro escolhe o quadro de baixo, a fracao vira
     a opacidade do de cima. Dois vizinhos acesos = dissolvencia continua,
     nao degrau. */
  (function () {
    var reduzir = window.matchMedia('(prefers-reduced-motion: reduce)');

    function ligar(palco) {
      if (palco.dataset.aprodPronto) return;
      palco.dataset.aprodPronto = '1';

      var quadros = palco.querySelectorAll('.aprod__quadro');
      if (quadros.length < 2) return;

      var dur = parseInt(palco.getAttribute('data-aprod-duracao'), 10) || 900;
      var rodando = false;

      function pintar(p) {
        var f = p * (quadros.length - 1);
        var base = Math.floor(f);
        if (base > quadros.length - 2) base = quadros.length - 2;
        var frac = f - base;
        for (var i = 0; i < quadros.length; i++) {
          quadros[i].style.opacity =
            i === base ? '1' : (i === base + 1 ? String(frac) : '0');
        }
      }

      function tocar() {
        if (rodando || reduzir.matches) return;
        rodando = true;
        var t0 = null;
        function passo(t) {
          if (t0 === null) t0 = t;
          var p = (t - t0) / dur;
          if (p > 1) p = 1;
          /* easeOutCubic: sai rapido e assenta. Linear parece mecanico. */
          pintar(1 - Math.pow(1 - p, 3));
          if (p < 1) requestAnimationFrame(passo);
          else rodando = false;
        }
        requestAnimationFrame(passo);
      }

      pintar(0);

      /* Disparo por PROGRESSO do trilho, nao por interseccao de elemento.
         IntersectionObserver com rootMargin depende da altura do alvo: um
         palco (ou uma coluna de bullets) mais alto que a faixa de disparo
         entra nela cedo e a animacao termina fora de vista. Progresso e'
         um numero de 0 a 1, igual em qualquer viewport. */
      var trilho = palco.closest('[data-aprod-trilho]');
      if (!trilho) { pintar(1); return; }

      var inicio = parseFloat(palco.getAttribute('data-aprod-inicio')) / 100;
      if (isNaN(inicio)) inicio = 0.2;
      var tocou = false, sujo = false;

      function conferir() {
        sujo = false;
        var r = trilho.getBoundingClientRect();
        var curso = r.height - window.innerHeight;
        var pr = curso > 0 ? -r.top / curso : (r.top < 0 ? 1 : 0);

        if (!tocou && pr >= inicio && pr <= 1.1) { tocou = true; tocar(); }
        /* rearma so quando o trilho saiu de vez, pra tocar de novo na volta */
        if (tocou && !rodando && (r.bottom < 0 || r.top > window.innerHeight)) {
          tocou = false; pintar(0);
        }
      }

      function marcar() {
        if (sujo) return;
        sujo = true;
        requestAnimationFrame(conferir);
      }

      window.addEventListener('scroll', marcar, { passive: true });
      window.addEventListener('resize', marcar);
      conferir();
    }

    function varrer() {
      var t = document.querySelectorAll('[data-aprod]');
      for (var i = 0; i < t.length; i++) ligar(t[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', varrer);
    } else {
      varrer();
    }
    document.addEventListener('shopify:section:load', varrer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aristocrata-desodorante-videos"] && !Shopify.designMode) return;
  try {
    
  /* Um clique toca com som, pausa os outros videos da pagina e congela a
     esteira - marquee andando embaixo de um video tocando e' desconfortavel. */
  (function () {
    var trilhos = document.querySelectorAll('[data-avid-trilho]');

    for (var t = 0; t < trilhos.length; t++) {
      (function (trilho) {
        var molduras = trilho.querySelectorAll('[data-avid-video]');

        function algumTocando() {
          for (var i = 0; i < molduras.length; i++) {
            var v = molduras[i].querySelector('video');
            if (v && !v.paused) return true;
          }
          return false;
        }

        /* Sai da tela, pausa. Sem isso um video some rolando e continua
           falando sozinho no meio da pagina. */
        var vigia = null;
        if (window.IntersectionObserver) {
          vigia = new IntersectionObserver(function (entradas) {
            for (var k = 0; k < entradas.length; k++) {
              if (!entradas[k].isIntersecting) {
                var v = entradas[k].target.querySelector('video');
                if (v && !v.paused) v.pause();
              }
            }
          }, { threshold: 0.35 });
        }

        for (var i = 0; i < molduras.length; i++) {
          (function (moldura) {
            var video = moldura.querySelector('video');
            if (!video) return;

            moldura.addEventListener('click', function () {
              if (video.paused) {
                /* UM de cada vez, na pagina inteira - inclui os videos da
                   tira de UGC da PDP, que sao outra secao. */
                var todos = document.querySelectorAll('video');
                for (var j = 0; j < todos.length; j++) {
                  if (todos[j] !== video) todos[j].pause();
                }
                video.muted = false;
                video.play();
              } else {
                video.pause();
              }
            });

            video.addEventListener('play', function () {
              moldura.classList.add('is-tocando');
              trilho.classList.add('avid--tocando');
            });

            video.addEventListener('pause', function () {
              moldura.classList.remove('is-tocando');
              if (!algumTocando()) trilho.classList.remove('avid--tocando');
            });

            video.addEventListener('ended', function () { video.pause(); });
            if (vigia) vigia.observe(moldura);
          })(molduras[i]);
        }
      })(trilhos[t]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
